const isStringOnlyNumbers = (str: string): boolean => /^\d+$/.test(str);

export default isStringOnlyNumbers;
